import React from 'react'
import {
    Grid,
    Typography,
    Container,
    Avatar
} from '@material-ui/core'
import { CameraAlt } from '@material-ui/icons'
import { Images } from 'salvatores'
import {
    ArrowBack
} from '@material-ui/icons'
import { CustomAppBar, CustomButton } from '../../../shared'
import { HomeX1, HomeX2, HomeX3, HomeT1, HomeT2, HomeT3, IDProofFrame } from '../../../assets/images'
import { getContent } from '../../../utils/helper'
import { supportedLanguageMapping } from '../../language/constants'

const HomeImage = ({ goBack, goToScreen, language, languageJSON, captureImage, step, homeImage, 
    submit, handleChange, isCameraOn }) => {
    return (
        <div>
            <CustomAppBar title={getContent(languageJSON, 'title_home_photo')}
                leftButton={<CustomButton variant="text" handleChange={goBack} label={<ArrowBack />} />}
                rightButton={<CustomButton variant="text" color="primary" handleChange={() => goToScreen('language', { to: 'addressProof' })} label={supportedLanguageMapping[language]} />} />
            {step === 1 ?
                <Container style={{ padding: 0 }}>
                    <Grid container justify="center" alignItems="center" spacing={2} style={{ padding: '2% 0%', maxHeight: '70vh', overflow: 'scroll' }}>
                        <Grid item xs={11} style={{ backgroundColor: '#FEF1F1', padding: '4%' }}>
                            <Typography variant="body1">
                                {getContent(languageJSON, 'subtitle_incorrect_ways_home_image')}
                            </Typography>
                            <Grid container justify="center" spacing={2} style={{ marginTop: '2%' }}>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '14vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={HomeX1} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'incorrect_home_image_suggestion_1')}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '14vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={HomeX2} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'incorrect_home_image_suggestion_2')}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '14vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={HomeX3} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'incorrect_home_image_suggestion_3')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={11} style={{ backgroundColor: '#F2FEF1', padding: '4%' }}>
                            <Typography variant="body1">
                                {getContent(languageJSON, 'subtitle_correct_ways_home_image')}
                            </Typography>
                            <Grid container justify="center" spacing={2} style={{ marginTop: '2%' }}>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '14vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={HomeT1} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'correct_home_image_suggestion_1')}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '14vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={HomeT2} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'correct_home_image_suggestion_2')}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '14vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={HomeT3} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'correct_home_image_suggestion_3')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
                : null}
{
    step === 2 ?
    <Container>
        <Grid container justify="center" spacing={4} style={{ maxHeight: '100vh', overflow: 'scroll', paddingBottom: 130 }}>
            <Grid item xs={11}>
                <Avatar variant="square" src={homeImage} style={{ width: '100%', height: '50vh', objectFit: 'contain' }} />
                <div style={{ margin: '5%' }}>
                    <Images
                        frameHeight={400}
                        frame={IDProofFrame}
                        title={getContent(languageJSON, 'action_retake_home_image')}
                        constraints={{
                            audio: false,
                            video: {
                                facingMode: "environment"
                            }
                        }}
                        cameraStateChange={() => {}}
                        content={
                            <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%' }} color="secondary" 
                                label={
                                    <Grid container alignItems="center" justify="center">
                                        <CameraAlt style={{ marginRight: 5 }} />
                                        <Typography style={{ fontSize: 12 }}>{getContent(languageJSON, 'action_retake_home_image')}</Typography>
                                    </Grid>} />
                        }
                        captureImage={captureImage} />
                </div>
            </Grid>
        </Grid>
    </Container>
    : null
}
{
    step === 1 ?
    <Grid container justify="center" alignItems="center" style={{ padding: '15px', position: !isCameraOn ? 'absolute' : '', bottom: 0, left: 0, backgroundColor: '#f7fdfd' }}>
        <Grid item xs={11}>
            <Images
                frameHeight={400}
                frame={IDProofFrame}
                title={getContent(languageJSON, 'title_home_photo')}
                constraints={{
                    audio: false,
                    video: {
                        facingMode: "environment"
                    }
                }}
                cameraStateChange={(value) => handleChange('isCameraOn', value)}
                content={
                    <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%', fontSize: 12 }} color="primary" 
                        label={
                        <Grid container alignItems="center" justify="center">
                            <CameraAlt style={{ marginRight: 5 }} />
                            <Typography variant="button">{getContent(languageJSON, 'action_capture_home_image')}</Typography>
                        </Grid>} />
                }
                captureImage={captureImage} />
        </Grid>
    </Grid> : <Grid container justify="center" alignItems="center" style={{ padding: '15px', position: !isCameraOn ? 'absolute' : '', bottom: 0, left: 0, backgroundColor: '#f7fdfd' }}>
        <Grid item xs={11}>
            <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%', fontSize: 12 }} color="primary" 
                label={<Typography variant="button">{getContent(languageJSON, 'action_submit_home_image')}</Typography>} handleChange={submit} />
        </Grid>
    </Grid>
}
        </div >
    )
}

export default HomeImage